<p-card
  [title]="horizontalTallComponentContentBanner().content.headline"
  class="flex tall-presentation w-full"
  styleClass="noBorder"
  [class.card-max-width]="!isResponsive()">
  <div
    class="inline-flex flex-1 justify-content-start align-items-center w-full inner-banner-gap"
    [class]="horizontalTallImagePositionRight() ? 'flex-column-lg-flex-row' : 'flex-column-lg-flex-row-reverse'">
    @if (horizontalTallComponentContentBanner().content.image && horizontalTallImagePositionRight()) {
      <div class="inline-flex flex-column full-lg-half-width h-full">
        <ppg-image
          [url]="horizontalTallImgUrl()"
          [height]="horizontalTallImgHeight()"
          [width]="horizontalTallImgWidth()"
          [description]="horizontalTallImgDescription()"
          class="flex w-full h-full align-items-center" />
      </div>
    }

    <div
      [class]="
        horizontalTallComponentContentBanner().content.showLogo
          ? 'horizontal-content-banner-body-with-icon'
          : 'horizontal-content-banner-body'
      "
      class="inline-flex flex-column full-lg-half-width">
      <div class="flex flex-column">
        @if (horizontalTallComponentContentBanner().content.showLogo) {
          <div class="logo">
            <img [ngSrc]="logo()" alt="PPG Logo" width="58" height="46" />
          </div>
        }
        <ppg-content-banner-headline
          [headline]="horizontalTallComponentContentBanner().content.headline"></ppg-content-banner-headline>
        <ppg-content-banner-subheading
          [subheading]="horizontalTallComponentContentBanner().content.subheading"></ppg-content-banner-subheading>

        <div>
          @for (contentItem of horizontalTallComponentContentBanner().content.content; track $index) {
            <ppg-rich-text class="description" [content]="contentItem.content"></ppg-rich-text>
          }
        </div>
        @if (horizontalTallPresentationContentBannerCta()) {
          <ppg-container-content-banner-cta [cta]="horizontalTallPresentationContentBannerCta()" />
        }
      </div>
    </div>
    @if (horizontalTallComponentContentBanner().content.image && !horizontalTallImagePositionRight()) {
      <div class="inline-flex flex-column full-lg-half-width h-full">
        <ppg-image
          [url]="horizontalTallImgUrl()"
          [height]="horizontalTallImgHeight()"
          [width]="horizontalTallImgWidth()"
          [description]="horizontalTallImgDescription()"
          class="flex w-full h-full align-items-center" />
      </div>
    }
  </div>
</p-card>
